import { ChangeEvent } from 'react';

interface AddWebServiceFormProps {
  onTextChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  textInput: string;
}

export const AddWebServiceForm = ({
  onTextChange,
  textInput,
}: AddWebServiceFormProps) => {
  return (
    <div className="flex flex-col gap-2">
      {/* URL Input Section */}
      <div className="flex flex-col gap-2">
        <h3 className="text-lg font-bold">Add API Definition URLs</h3>
        <p className="text-chariot-text-secondary text-sm">
          Enter one per line:
        </p>
        <textarea
          className="bg-chariot-background-primary border-chariot-stroke text-chariot-text-primary focus:border-chariot-brand-primary h-32 rounded-lg border-2 p-3 font-mono text-sm focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50"
          placeholder="https://example.com/api/openapi.json&#10;https://api.example.com/swagger.yaml"
          value={textInput}
          onChange={onTextChange}
          data-testid="webservice-url-input"
        />
      </div>
    </div>
  );
};
